import React, { useState } from 'react';

const defaultValue = {
  modal: '',
  modalEmpresa: '',
  empresa: {},
  pendencias: {},
  errosFaturamento: {},
  errosCancelamento: {},
  errosEmissao: {},
  possuiIpi: false,
  possuiIcms: false,
  modalRelatorios: '',
  modalFechamentoPeriodo: '',
  modalPendenciasFaturamento: '',
  modalErrosFaturamento: '',
  dadosKanban: {},
  modalAlterarSenha: '',
  dateKanban: '',
  usuarioAtual: {},
  termoUsoModal: '',
  termoUso: {},
  indicesMonetariosModal: '',
  indiceMonetario: '',
  loading: false,
  nomeEmpresa: '',
  modalValidacaoCliente: '',
  modalWelcomeInicial: '',
  modalVisaoGeral: '',
  funcionalidadesTour: [],
  visualizarDadosDashboard: true,
};

export const GlobalContext = React.createContext({});

export const GlobalProvider = (props) => {
  return (
    <GlobalContext.Provider
      value={{
        modal: useState(defaultValue.modal),
        modalEmpresa: useState(defaultValue.modalEmpresa),
        empresa: useState(defaultValue.empresa),
        pendencias: useState(defaultValue.pendencias),
        errosFaturamento: useState(defaultValue.errosFaturamento),
        errosCancelamento: useState(defaultValue.errosCancelamento),
        errosEmissao: useState(defaultValue.errosEmissao),
        possuiIpi: useState(defaultValue.possuiIpi),
        possuiIcms: useState(defaultValue.possuiIcms),
        modalRelatorios: useState(defaultValue.modalRelatorios),
        modalFechamentoPeriodo: useState(defaultValue.modalFechamentoPeriodo),
        modalPendenciasFaturamento: useState(defaultValue.modalPendenciasFaturamento),
        modalErrosFaturamento: useState(defaultValue.modalErrosFaturamento),
        dadosKanban: useState(defaultValue.dadosKanban),
        dateKanban: useState(defaultValue.dateKanban),
        modalAlterarSenha: useState(defaultValue.modalAlterarSenha),
        usuarioAtual: useState(defaultValue.usuarioAtual),
        termoUsoModal: useState(defaultValue.termoUsoModal),
        termoUso: useState(defaultValue.termoUso),
        indicesMonetariosModal: useState(defaultValue.indicesMonetariosModal),
        indiceMonetario: useState(defaultValue.indiceMonetario),
        loading: useState(defaultValue.loading),
        nomeEmpresa: useState(defaultValue.nomeEmpresa),
        modalValidacaoCliente: useState(defaultValue.modalValidacaoCliente),
        modalWelcomeInicial: useState(defaultValue.modalWelcomeInicial),
        modalVisaoGeral: useState(defaultValue.modalVisaoGeral),
        funcionalidadesTour: useState(defaultValue.funcionalidadesTour),
        visualizarDadosDashboard: useState(defaultValue.visualizarDadosDashboard),
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};

export const GlobalConsumer = GlobalContext.Consumer;
